import checkAccess from "@/access/checkAccess";
import router from "@/router";
import ACCESS_ENUM from "@/access/accessEnum";
import { useLoginUserStore } from "@/store/userStore";

router.beforeEach(async (to, from, next) => {
  // 获取登陆用户信息
  const loginUserStore = useLoginUserStore();
  // 加 await 是为了等用户登录成功之后，再执行后续的代码
  await loginUserStore.fetchLoginUser();
  let loginUser = loginUserStore.loginUser;
  // 如果之前没进行登陆过，自动登录

  const needAccess = (to.meta?.access as string) ?? ACCESS_ENUM.NOT_LOGIN;

  // 要跳转的页面必须要登陆
  if (needAccess !== ACCESS_ENUM.NOT_LOGIN) {
    // 如果需要登录，且当前没有用户信息（或用户信息为空），则尝试获取
    if (!loginUser || !loginUser.userRole) {
      await loginUserStore.fetchLoginUser();
      loginUser = loginUserStore.loginUser;
    }

    // 如果没登陆，跳转到登录页面
    if (
      !loginUser ||
      !loginUser.userRole ||
      loginUser.userRole === ACCESS_ENUM.NOT_LOGIN
    ) {
      next(`/user/login?redirect=${to.fullPath}`);
      return;
    }
    // 如果已经登陆了，但是权限不足，那么跳转到无权限页面
    if (!checkAccess(loginUser, needAccess)) {
      next("/noAuth");
      return;
    }
  }
  next();
});
